// =====================================================
// 📁 POSEmptyState.tsx
// =====================================================

import { ShoppingCart } from 'lucide-react';

interface Props {
  title: string;

  description?: string;

  icon?: React.ReactNode;

  minHeight?: string;
}

const POSEmptyState: React.FC<Props> = ({
  title,
  description,
  icon,
  minHeight = '300px',
}) => {
  return (
    <div
      className="
        flex
        items-center
        justify-center

        rounded-2xl

        border
        border-stroke

        bg-white

        p-8

        shadow-1

        dark:border-strokedark
        dark:bg-boxdark-2
      "
      style={{
        minHeight,
      }}
    >
      <div className="text-center">
        {/* ===================================================== */}
        {/* 🔹 Icon */}
        {/* ===================================================== */}

        <div
          className="
            mx-auto

            flex
            h-18
            w-18

            items-center
            justify-center

            rounded-2xl

            border
            border-primary/10

            bg-primary/5

            text-primary

            dark:border-primary/20
            dark:bg-primary/10
          "
        >
          {icon || <ShoppingCart size={34} />}
        </div>

        {/* ===================================================== */}
        {/* 🔹 Title */}
        {/* ===================================================== */}

        <h3
          className="
            mt-5

            text-lg
            font-semibold

            text-black

            dark:text-white
          "
        >
          {title}
        </h3>

        {/* ===================================================== */}
        {/* 🔹 Description */}
        {/* ===================================================== */}

        {description && (
          <p
            className="
              mx-auto
              mt-2

              max-w-[320px]

              text-sm
              leading-relaxed

              text-body

              dark:text-bodydark1
            "
          >
            {description}
          </p>
        )}
      </div>
    </div>
  );
};

export default POSEmptyState;
